import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Menu, X, ArrowRight } from 'lucide-react'
import { MobileNav } from './MobileNav'
import { SOCIAL_MEDIA } from '@/lib/constants'
import { LinkedInIcon, InstagramIcon, FacebookIcon } from './icons/social-icons'

export function Header() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <header className="border-primary sticky top-0 z-40 w-full border-b bg-gray-950/90 backdrop-blur-md">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4">
          <Link to="/" className="text-foreground flex flex-shrink-0 items-center gap-2.5">
            <img src="/logo-mark.svg" alt="" aria-hidden="true" className="h-9 w-auto" />
            <span className="text-3xl font-bold tracking-tight">Fugue Lab</span>
          </Link>

          {/* Desktop nav */}
          <nav aria-label="Main" className="hidden items-center gap-x-6 md:flex">
            <Link to="/" className="text-muted-foreground hover:text-foreground text-sm transition">
              Home
            </Link>
            <Link to="/who-we-help" className="text-muted-foreground hover:text-foreground text-sm transition">
              Who We Help
            </Link>
            <Link to="/packages" className="text-muted-foreground hover:text-foreground text-sm transition">
              Packages
            </Link>
            <Link to="/resources" className="text-muted-foreground hover:text-foreground text-sm transition">
              Resources
            </Link>
            <Link to="/portfolio" className="text-muted-foreground hover:text-foreground text-sm transition">
              Portfolio
            </Link>
            <Link to="/about" className="text-muted-foreground hover:text-foreground text-sm transition">
              About
            </Link>
            <Link
              to="/get-started"
              className="bg-primary text-primary-foreground hover:bg-primary/90 inline-flex items-center justify-center gap-1.5 rounded-md px-5 py-2 text-sm font-medium transition"
            >
              Get Started <ArrowRight className="h-4 w-4" />
            </Link>
            <a
              href={SOCIAL_MEDIA.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Fugue Lab LinkedIn"
              className="text-muted-foreground hover:text-primary transition-colors"
            >
              <LinkedInIcon className="h-5 w-5" />
            </a>
            <a
              href={SOCIAL_MEDIA.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Fugue Lab Instagram"
              className="text-muted-foreground hover:text-primary transition-colors"
            >
              <InstagramIcon className="h-5 w-5" />
            </a>
            <a
              href={SOCIAL_MEDIA.facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Fugue Lab Facebook"
              className="text-muted-foreground hover:text-primary transition-colors"
            >
              <FacebookIcon className="h-5 w-5" />
            </a>
          </nav>

          {/* Mobile toggle */}
          <div className="md:hidden">
            <button onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu">
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </header>

      <MobileNav isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  )
}
